module.exports = __webpack_public_path__ + "img/cannaplan-logo.97feb940.svg";